import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle, Waves } from 'lucide-react';

export default function BillingCancelPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-white px-4" data-testid="billing-cancel-page">
      <div className="max-w-md w-full text-center rounded-2xl border border-[#1f1f1f] bg-[#121212] p-10">
        <Waves className="h-7 w-7 text-[#00D4FF] mx-auto mb-3" />
        <XCircle className="h-10 w-10 text-gray-500 mx-auto my-4" />
        <h1 className="text-2xl font-black mb-1">Checkout cancelled</h1>
        <p className="text-xs text-gray-400 mb-6">No charge was made. You can try again any time.</p>
        <Link to="/billing" className="inline-block px-5 py-2.5 rounded-lg bg-[#FF4D94] text-white text-xs font-bold hover:brightness-110" data-testid="billing-cancel-back-btn">
          Back to billing
        </Link>
      </div>
    </div>
  );
}
